import { BasePage } from "./Base";

export function ExamplesPage(props) {
  return (
    <BasePage pageHeader="Example Projects">
    </BasePage>
  );
}